package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.KitchenLocationPrintersEnum
import org.hs_soft.runmynesto.domain.util.Constants.ipAddressRegex
import org.hs_soft.runmynesto.domain.util.Constants.sunmiSerialLength


@Serializable
data class GetCashRegisterConfigResponse(
    @SerialName("getCashRegisterConfig")
    val cashRegisterConfig: CashRegisterConfig?=null,
    @SerialName("updateCashRegisterConfigsList")
    val updateCashRegisterConfig: CashRegisterConfig?=null,
)

@Serializable
data class CashRegisterConfig(
    val id: Int ?= 0,
    val modVer: Int ?= 0,
    val appType: String ?= "",
    val state: String ?= "",
    val hardwareId: String ?= "",
    val country: Int ?= 0,
    val language: Int ?= 0,
    val taxNormalRate: Double ?= 0.0,
    val taxReducedRate: Double ?= 0.0,
    val taxHotelRate: Double ?= 0.0,
    val companyVATNo: String ?= "",
    val companyTitle: String ?= "",
    val companyName: String ?= "",
    val companyAddition: String ?= "",
    val companyStreet: String ?= "",
    val companyZIP: String ?= "",
    val companyCity: String ?= "",
    val companyTelephone: String ?= "",
    val companyOptional1: String ?= "",
    val companyOptional2: String ?= "",
    val restaurantDesignId: Int ?= 0,
    val restaurantDefaultRoomId: Int ?= 0,
    val restaurantAvailableRooms: List<RestaurantRoom> ?= emptyList(),
    val receiptPrintersConfig: List<ReceiptPrinterConfig> ?= emptyList(),
    val separateKitchenReports: Boolean ?= false,
    val showPriceOnKitchenReport: Boolean ?= false,
    val printNextCoursePositions: Boolean ?= false,
    val kitchenStations: List<KitchenStation> ?= emptyList(),
    val availableKds: List<SunmiDeviceDetails> ?= emptyList(),
    val availablePrinters: List<SunmiDeviceDetails> ?= emptyList(),
    val hsPayStores: List<HSPayStore> ?= emptyList(),
    val eftConfig: EFTConfig ?= EFTConfig(),
    val hsPayStoreId: String ?= ""
) {
    fun getLanguageDisplayName(): String {
        return when (language) {
            1 -> LanguageEnum.English.displayName
            2 -> LanguageEnum.German.displayName
            3 -> LanguageEnum.French.displayName
            4 -> LanguageEnum.Italian.displayName
            7 -> LanguageEnum.Portuguese.displayName
            else -> LanguageEnum.English.displayName
        }
    }
}

@Serializable
data class ReceiptPrinterConfig(val type: String, val connectionTarget: String, val roomIds: List<Int> = emptyList())

@Serializable
data class RestaurantRoom(val id: Int, val caption: String)

@Serializable
data class KitchenStation(
    val id: Int,
    val isActive: Boolean,
    val name: String,
    val type: String,
    val connectionTarget: String,
    val kdsSN: String,
    val waiterCopy: Boolean,
    val tableShiftReceipt: Boolean,
    val isAnnounce: Boolean,
    val roomIds: List<Int> = emptyList()
) {
    fun getType(): KitchenLocationPrintersEnum? {
        return when(type.trim()) {
            "sunmi" -> KitchenLocationPrintersEnum.SUNMI_CLOUD_BY_IP

            "sunmi_cloud" -> KitchenLocationPrintersEnum.SUNMI_CLOUD_BY_SERVER

            "local_printer" -> {
                if (Regex(ipAddressRegex).matches(connectionTarget)) {
                    KitchenLocationPrintersEnum.EPSON_M30
                } else if (kdsSN.isNotBlank() && kdsSN.length == sunmiSerialLength) {
                    KitchenLocationPrintersEnum.KITCHEN_DISPLAY_KDS
                } else null
            }

            "" -> if (kdsSN.isNotBlank() && kdsSN.length == sunmiSerialLength) {
                KitchenLocationPrintersEnum.KITCHEN_DISPLAY_KDS
            } else null

            else -> null
        }
    }

    fun isActiveField(): String = "kitchenStation${id}Active"
    fun waiterCopyField(): String = "kitchenStation${id}WaiterCopy"
    fun tableShiftReceiptField(): String = "kitchenStation${id}TableShiftReceipt"
    fun announceField(): String = "kitchenStation${id}Announce"
    fun ipField(): String = "kitchenStation${id}_IP"
    fun idField(): String = "kitchenStation${id}_ID"
    fun roomsField(): String = "kitchenStation${id}Room"
}

@Serializable
data class SunmiDeviceDetails(val sn: String, val name: String)

@Serializable
data class HSPayStore(val id: String, val name: String)

@Serializable
data class EFTConfig(
    val type: Int ?= 0,
    val ip: String ?= "",
    val port: Int ?= 0,
    val tid: String ?= "",
    val hsPayStoreId: String ?= "",
    val hsPayPoiId: String ?= "",
    val hsPayUrl: String ?= "",
    val hsPayApiKey: String ?= "",
    val walleeKey: String ?= "",
    val walleeVirtualTid: String ?= "",
    val walleeUser: String ?= "",
    val walleeSpace: String ?= "",
    val walleeTid: String ?= "",
    val printEftReceipt: Boolean ?= false
)